export default __webpack_public_path__ + "static/media/T_Tartaruga.ad51de7e.svg";